<template>
  <div class="search-headline">
    <div class="search-headline__title">
      {{ title }}
    </div>

    <div class="search-headline__text">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchHeadline',
  props: {
    title: { type: String },
    text: { type: String },
  },
}
</script>

<style lang="scss" scoped>
.search-headline {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  white-space: nowrap;

  &__title {
    color: var(--typography-title01);
    @include promo-heading-2;

    @include media(tablet) {
      @include hero-display-5;
    }
  }

  &__text {
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 16px;
    color: var(--typography-body01);
    @include body-caption;

    @include media(tablet) {
      @include body-text-big;
    }
  }
}
</style>
